(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["size-guide"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var openBtn = event.target.closest('[data-ps-sizeguide-open]');
    if (openBtn) {
      var wrap = openBtn.closest('.ps-sizeguide');
      var dialog = wrap && wrap.querySelector('[data-ps-sizeguide-dialog]');
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
      return;
    }
    var closeBtn = event.target.closest('[data-ps-sizeguide-close]');
    if (closeBtn) {
      var dlg = closeBtn.closest('[data-ps-sizeguide-dialog]');
      if (dlg) dlg.close();
      return;
    }
    if (event.target.matches('[data-ps-sizeguide-dialog]')) {
      event.target.close();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
